import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";

import PrintTable from "../common/PrintTable";
import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";
import lbl from "../../../data/Labels.json";
import Option from "../../common/RowOption";

const ExpensesSubAccounts = (props) => {
  const [data, setData] = useState([]);
  const { tid, aid,  said, halfYearId } = props.match.params;

  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];

  const columns = [
    { path: "id", label: "شماره" },
    { path: "payment_date", label: "تاریخ پرداخت" },
    { path: "contractor", label: "طرف قرارداد" },
    { path: "paid_by_staff", label: "پرداخت کننده" },
    { path: "account", label: "حساب" },
    { path: "remark", label: "ملاحظه" },
    { path: "bank_ref_no", label: "ریفرنس نمبر" },
    { path: "amount", label: "مبلغ" },
  ];

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    try {
      let query = `expenses/types/${tid}/accounts/${aid}/subAccounts/${said}/expenses?halfYearId=${halfYearId}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper">
      <PrintHeader
        title={data?.summary?.title}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
      <div style={{display: "grid", gridTemplateColumns: "auto auto auto", paddingTop: "50px"}}>
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{width: "80%"}}>
              <hr/>
              <p>نام و امضاء تایید کننده</p>
            </div>
          </div>
        </div>
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{width: "80%"}}>
              <hr/>
              <p>نام و امضاء پرداخت کننده</p>
            </div>
          </div>
        </div>
        <div className="print-identity">
          <div className="print-signature-area">
            <div className="wrapper" style={{width: "80%"}}>
              <hr/>
              <p>نام و امضاء گیرنده</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ExpensesSubAccounts;
